import React from 'react';
import Chart from './BarChart';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { REDUCER_NAME } from '../reducer';
import Const from '../Const';
import {
  formatPrice,
  formatVolume,
  formatTextFloat,
} from '../../../helpers/Text';
import Loading from './../../../common/loading/Loading';
import { withComponentId } from './../../../common/ComponentIdContext';
import { compose } from 'redux';
import { THEMES } from './../../../../configs/LayoutConfig';

class ChartComponent extends React.Component {
  getMaxData(data) {
    const arrValue = [];
    data.forEach(item => {
      const total =
        item[Const.chartData.buyUpVolume] +
        item[Const.chartData.sellDownVolume] +
        item[Const.chartData.naVolume];
      arrValue.push(total);
    });
    return Math.max(...arrValue);
  }

  getMaxValue = array => {
    const { isDerivatives } = this.props;
    const maxValueY = array
      ? Math.max.apply(
          Math,
          array.map(function(item) {
            return item.y;
          }),
        )
      : null;
    const totalX1 = array
      ? array.reduce((item1, item2) => {
          return item1 + item2.x1;
        }, 0)
      : null;
    const totalX2 = array
      ? array.reduce((item1, item2) => {
          return item1 + item2.x2;
        }, 0)
      : null;
    const totalX3 = array
      ? array.reduce((item1, item2) => {
          return item1 + item2.x3;
        }, 0)
      : null;
    const x4 = array[0].x4;

    return {
      title: isDerivatives
        ? totalX1 + totalX2 + totalX3
        : formatTextFloat(totalX1 + totalX2 + totalX3),
      y: maxValueY,
      x1: totalX1,
      x2: totalX2,
      x3: totalX3,
      x4,
    };
  };

  getHeightChart = length => {
    return length * 16 + (length - 1) * 10 + 70;
  };

  render() {
    const {
      width,
      data,
      info: { ReferencePrice },
      isFetching,
      theme,
      isDerivatives,
    } = this.props;
    const maxValue = this.getMaxData(data);
    const cloneData = data.map(item => {
      const price = isDerivatives
        ? item[Const.chartData.price]
        : formatPrice(item[Const.chartData.price]);

      const buyUpVolume = isDerivatives
        ? item[Const.chartData.buyUpVolume]
        : formatVolume(item[Const.chartData.buyUpVolume]);
      const sellDownVolume = isDerivatives
        ? item[Const.chartData.sellDownVolume]
        : formatVolume(item[Const.chartData.sellDownVolume]);
      const naVolume = isDerivatives
        ? item[Const.chartData.naVolume]
        : formatVolume(item[Const.chartData.naVolume]);
      return {
        title: isDerivatives
          ? buyUpVolume + sellDownVolume + naVolume
          : formatTextFloat(buyUpVolume + sellDownVolume + naVolume),
        y: price,
        x1: buyUpVolume === 0 ? null : buyUpVolume,
        x2: sellDownVolume === 0 ? null : sellDownVolume,
        x3: naVolume === 0 ? null : naVolume,
        x4: isDerivatives ? maxValue / 2.5 : formatVolume(maxValue / 2.5),
        // x4 for bonus value width bar chart to show full label on the right side of bar equal 1/4 max value
      };
    });

    const sortedData = cloneData.slice().sort((a, b) => a.y - b.y);

    const labelColor = theme === THEMES.DARK ? '#ffffff' : '#1f2023';

    return (
      <div className="h-100">
        {isFetching && <Loading />}
        {sortedData.length && !isFetching ? (
          <>
            <Chart
              data={sortedData}
              width={width}
              height={this.getHeightChart(sortedData.length)}
              ratio={window.devicePixelRatio}
              middleValue={
                isDerivatives ? ReferencePrice : formatPrice(ReferencePrice)
              }
              labelColor={labelColor}
              theme={theme}
              isDerivatives={isDerivatives}
            />
            <div className="chart-legend">
              <div className="chart-legend__item">
                <div className="square square--green" />
                <div className="title">
                  {I18n.t('timeAndSale.chartLegend.buyUp')}
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--red" />
                <div className="title">
                  {I18n.t('timeAndSale.chartLegend.sellDown')}
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--blue" />
                <div className="title">
                  {I18n.t('timeAndSale.chartLegend.unidentified')}
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    i18n: state.i18n,
    theme: state.theme,
    isFetching: state[REDUCER_NAME].listMultiComponent[componentId].isFetching,
    data:
      state[REDUCER_NAME].listMultiComponent[componentId].timeAndSaleData
        .timeAndSales,
    info: state[REDUCER_NAME].listMultiComponent[componentId].topContent,
    isDerivatives:
      state[REDUCER_NAME].listMultiComponent[componentId].condition
        .isDerivatives,
  };
};

ChartComponent.defaultProps = {
  data: [],
  info: {},
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(ChartComponent);
